var map = {
	"./brawlertoken.png": 3678,
	"./bridge_banner.png": 3025,
	"./diggerstoken.png": 3679,
	"./farmerpets.png": 3680,
	"./farmingtoken.png": 3681,
	"./novopangea.png": 3682,
	"./old_novopangea.png": 3683,
	"./outlawtroopers.png": 3684,
	"./pinup24heels.png": 3685,
	"./zombiecointk.png": 3686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3677;